import { clsx } from 'clsx';
import { FC } from 'react';
import { NavigationItemStoryblok } from 'storyblok-types';
import { ItemLevel1 } from 'organisms/Header/Navigation/ItemLevel1';
import { motion } from 'modules/framer-motion';
import { getFadeAnimation } from 'modules/framer-motion/presets';
import styles from './Submenu.module.css';

interface SubMenuProps {
  navigationItems?: NavigationItemStoryblok[];
  visibleItem: NavigationItemStoryblok | null;
  activeItem?: NavigationItemStoryblok;
  setVisibleItem: (items: NavigationItemStoryblok | null) => void;
}

export const SubMenu: FC<SubMenuProps> = ({
  navigationItems,
  visibleItem,
  activeItem,
  setVisibleItem,
}) => {
  return (
    <motion.div {...getFadeAnimation()} className={styles.root}>
      <motion.ul className={styles.list}>
        {navigationItems?.map((item: NavigationItemStoryblok) => {
          const isOpen = visibleItem?._uid === item._uid;
          const isActive = activeItem?._uid === item._uid;

          return (
            <li
              key={item._uid}
              className={clsx(isOpen && styles.open, isActive && styles.active)}
            >
              <ItemLevel1
                item={item}
                className={styles.item}
                setVisibleItem={() => setVisibleItem(isOpen ? null : item)}
              />
            </li>
          );
        })}
      </motion.ul>
    </motion.div>
  );
};
